import { io } from 'socket.io-client';

class SocketioService {
  socket;
  constructor() {}

  setupSocketConnection() {
    // this.socket = io("https://test.domain:3001/");
    //this.socket = io("https://supportteam.webmoney.com/");
    this.socket = io(process.env.VUE_APP_SOCKET_URL)
  }
}

export default new SocketioService();
